import { render, staticRenderFns } from "./TicketCategories.vue?vue&type=template&id=3b5c2111&scoped=true"
import script from "./TicketCategories.vue?vue&type=script&lang=js"
export * from "./TicketCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5c2111",
  null
  
)

export default component.exports